// extracted by mini-css-extract-plugin
export default {"chatRoot":"Chat_chatRoot__Hl5MD"};